import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import { useEffect } from 'react';
import doResize from '@src/utils/do-resize';
import useFunLinkPageData from '@src/utils/use-fun-link-page-data.js';
import { jumpPage } from '@src/utils/common-util';
import { getLocales } from '@src/global-locales/get-page-locales-data';
import Toast from '@src/components/toast';
class MechaListStore extends BaseStore {
  @observable isActive = false;

  @observable mechaList = [];

  /**
   * 跳转到对应机甲详情页
   * @param mechaId
   */
  onRedirectToDetail = mechaId => {
    // 6月9号前屏蔽入口
    // Toast.info(getLocales('global.comming_soon'));
    // return false;
    if (!IS_DEV_ENV) {
      const url = 'mecha.html';
      jumpPage(url, `#/?mecha_id=${mechaId}`);
    } else {
      this.redirect(`/mecha?mecha_id=${mechaId}`);
    }
  };

  backTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  use() {
    super.use();

    const pageData = useFunLinkPageData();

    useEffect(
      () => {
        if (pageData) {
          this.mechaList = pageData?.mecha_list;
        }
      },
      [pageData]
    );
    useMount(() => {});

    useEffect(() => {
      doResize();
    }, []);
  }
}

export default MechaListStore;
